import { render, staticRenderFns } from "./shopmanage.vue?vue&type=template&id=bb1f5dda&scoped=true&"
import script from "./shopmanage.vue?vue&type=script&lang=js&"
export * from "./shopmanage.vue?vue&type=script&lang=js&"
import style0 from "./shopmanage.vue?vue&type=style&index=0&id=bb1f5dda&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb1f5dda",
  null
  
)

export default component.exports